import { getVersionByCode, isVersion } from '@/micro/common/app_store'
import { createLinkElement } from '@/micro/common/elements'

const useRouterGuards = () => {
  const validateAuth = (_to, is_auth) =>
    (_to.name === 'nmsOptionContact' || _to.name == 'nmsHome') && !is_auth

  const validateVersion = (_to, version) =>
    (_to.name === 'nmsOptionContact' || _to.name === 'nmsHome') &&
    (!isVersion(_to.params.version as string) || _to.params.version !== version)

  const validateEmpty = _to => _to.path === '/'

  const redirectIsNotAuth = (
    prefix: string,
    versionCache: string,
    prefixRedirect: string,
    section_name: string
  ) => {
    const section = section_name == 'nmsOptionContact' ? 'contact-options' : ''
    const link = `https://${prefix}.alegra.com/user/login/country/${versionCache}?redirect_to=https://${prefixRedirect}soporte.alegra.com/${versionCache}/${section}`
    createLinkElement(link)
  }

  const getVersionWithoutAuth = async () => {
    const response = await fetch(
      'https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location'
    )
    const { country } = await response.json()
    const version = getVersionByCode(country)
    return version
  }

  return {
    validateVersion,
    validateAuth,
    validateEmpty,
    redirectIsNotAuth,
    getVersionWithoutAuth,
  }
}

export default useRouterGuards
